import "./Rooms.scoped.scss"
import Room from "./Room";
import { useRecoilState } from "recoil";
import roomsState from "../../atoms/rooms";
import moment from "moment";
import waitingRoomState, { RoomsSortingType } from "../../atoms/waiting-room";

function Rooms() {
  const [rooms] = useRecoilState(roomsState);
  const [waitingRoom] = useRecoilState(waitingRoomState);

  let sortedRooms = rooms.filter((room) => room.id !== '' && room.id !== 'square');
  // Sorting handling
  if (waitingRoom.roomsSorting === RoomsSortingType.SORT_IN_NEWER) {
    sortedRooms = sortedRooms.reverse();
  } else if (waitingRoom.roomsSorting === RoomsSortingType.SORT_IN_PARTICIPANTS) {
    sortedRooms.sort((a, b) => b.uniqueParticipants - a.uniqueParticipants);
  }

  const thumbnailUrlTailer = Math.floor(moment().unix() / 60);

  return (
    <div className="rooms">
      {sortedRooms.map((room, index) => {
        const thumbnailUrl = room.ownerDetail.hasThumbnail
        ? `/data/member_image/${room.owner.substring(0, 2)}/${room.owner}.gif?${thumbnailUrlTailer}`
        : '/img/profile.png';

        return (
          <Room 
            key={index}
            thumbnailUrl={thumbnailUrl}
            name={room.name}
            participants={room.uniqueParticipants}
            maxParticipants={room.maxParticipants}
            ownerLevel={room.ownerDetail.level}
            ownerName={room.ownerDetail.nickname}
            roomId={room.id}
            isSecret={room.isSecret}
          />
        )
      })}
    </div>
  );
}

export default Rooms;
